import update from 'immutability-helper';
import { t } from 'i18next';

import {
  RESET,
  SET_REGISTER,
  APPEND_TO_REGISTER,
  GETTING_DATA,
  GETTING_PREV_DATA,
  ERROR_GETTING_DATA,
  CLEAR_REGISTER,
  DELETE_ITEM_FROM_REGISTER,
  UPDATE_ITEM_IN_REGISTER,
  PUSH_INSERT,
  SET_APPROVALS_MODE,
  SET_ARCHIVE_MODE,
} from '../actions/actions.types';

let schema = {
  list: [],
  itemActions: [],
  moreToGet: true,
  gettingData: false,
  gettingPrevData: false,
  scrollToElementId: null,
  counter: 0,
  approvalsMode: false,
  approvalsSubMode: 'ToApprove',
  approvalsRequestsMode: t('All'),
  archiveMode: false,
};
let resetSchema = JSON.stringify(schema);

export default function Register(state = schema, action) {
  switch (action.type) {
    case RESET:
      return JSON.parse(resetSchema);

    case GETTING_DATA:
      return update(state, {
        gettingData: { $set: true },
      });

    case GETTING_PREV_DATA:
      return update(state, {
        gettingPrevData: { $set: true },
      });

    case ERROR_GETTING_DATA:
      return update(state, {
        gettingData: { $set: false },
      });

    case APPEND_TO_REGISTER:
      let newList = [...state.list];
      action.data.forEach(item => {
        item.pageNumber = action.pageNumber;
        newList.push(item);
      });
      return update(state, {
        list: { $set: newList },
        moreToGet: { $set: action.data.length > 0 ? true : false },
        gettingData: { $set: false },
        gettingPrevData: { $set: false },
        scrollToElementId: { $set: null },
        counter: { $set: state.counter + 1 },
      });

    case SET_REGISTER:
      let moreFlag = action.data.length > 0 ? true : false;
      return update(state, {
        list: {
          $set: action.data.map(item => ({
            pageNumber: action.pageNumber,
            ...item,
          })),
        },
        moreToGet: { $set: moreFlag },
        gettingData: { $set: false },
        gettingPrevData: { $set: false },
        scrollToElementId: { $set: null },
        counter: { $set: state.counter + 1 },
      });
    case CLEAR_REGISTER:
      return update(state, {
        list: { $set: [] },
        itemActions: { $set: [] },
      });
    case DELETE_ITEM_FROM_REGISTER:
      let deleteItemIndex = getItemIndexById(state.list, action.itemId);
      if (deleteItemIndex === null) {
        return state;
      }
      return update(state, {
        list: {
          $splice: [[deleteItemIndex, 1]],
        },
      });

    case UPDATE_ITEM_IN_REGISTER:
      let updateItemIndex = getItemIndexById(state.list, action.itemId);
      if (updateItemIndex === null) {
        return state;
      }
      return update(state, {
        list: {
          [updateItemIndex]: {
            $set: action.updatedItem,
          },
        },
        itemActions: {
          [action.itemId]: { $set: null },
        },
        gettingData: { $set: false },
      });

    case PUSH_INSERT:
      return update(state, {
        list: {
          $push: [action.item],
        },
        itemActions: {
          [action.item.id]: { $set: null },
        },
      });

    case SET_APPROVALS_MODE:
      return update(state, {
        approvalsMode: { $set: action.approvalsMode },
        approvalsSubMode: { $set: action.subMode },
        approvalsRequestsMode: { $set: t(action.requestsMode) },
      });

    case SET_ARCHIVE_MODE:
      return update(state, {
        archiveMode: { $set: action.archiveMode },
      });

    default:
      return state;
  }
}

function getItemIndexById(list, id) {
  let itemIndex = null;
  if (id !== undefined && id !== null) {
    for (let i = 0; i < list.length; i++) {
      if (list[i].id === id) {
        itemIndex = i;
        break;
      }
    }
  }
  return itemIndex;
}
